module.exports = __webpack_public_path__ + "img/newLogo.c4be4936.png";